import React from 'react';

export default () => (
  <section className="completed-assignment">
    {'You\'ve marked your article as complete.'}
  </section>
);
